import axiosMiddleware from "./axiosMiddleware";
// --------------------------------------------------------------------------------
export const getWalletBalancesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: "wallet/balance",
  });
};
